<template>
  <div id="app">
    <router-view />
    <!-- 用户中心 -->
    <Profile />
  </div>
</template>

<script>
import Profile from "@/components/Profile";

export default {
  name: "App",
  components: {
    Profile,
  },
  data: () => ({}),
  mounted() {},
};
</script>

<style lang="less">
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f9f9f9;
  overflow: hidden;
}
</style>
